import PaySlipCard from "./paySlipCard";
export default PaySlipCard;